import React, { useCallback, useEffect } from 'react';
import * as Styles from './PixContent.styles';
import { CopySnippet, IconClock } from 'gatorcomponents';
import { Timer } from '@/pages/common/v1';


const PixContent = ({
  qrCode,
  code,
  limitTimeInSecondsToDisplayPixCode,
  handleFnishTimer,
  onPaymentSuccessPix,
  requestInvoiceStatus,
  loading,
  invoiceDetails,
  title = 'content title',
  copyTimerText = 'copy timer text',
  list = [
    'sample',
  ],
}) => {
  const handleFinish = () => {
    handleFnishTimer && handleFnishTimer();
  };

  const checkPixStatus = useCallback(() => {
    if (!loading) {
      if (!invoiceDetails.status) {
        requestInvoiceStatus();
      }

      if (invoiceDetails.status) {
        if (invoiceDetails.data.invoice.status.toLowerCase() === 'paid') {
          onPaymentSuccessPix();
        }

        if (invoiceDetails.data.invoice.status.toLowerCase() !== 'paid') {
          requestInvoiceStatus();
        }
      }
    }
  }, [
    requestInvoiceStatus,
    invoiceDetails,
    loading,
    onPaymentSuccessPix,
  ]);

  useEffect(() => {
    checkPixStatus();
  }, [checkPixStatus]);

  return (
    <Styles.Wrapper>
      <Styles.Title data-testid="title">
        {title}
      </Styles.Title>

      <Styles.QrCode
        src={`data:image/png;base64,${qrCode}`}
        loading="lazy"
        data-testid="qrCode"
      />

      <Styles.TimeMessageWrapper>
        <Styles.TimeMessage data-testid="timeMessage">
          <IconClock />
          {copyTimerText}
          <Timer
            startSecound={limitTimeInSecondsToDisplayPixCode === null ? 0 : limitTimeInSecondsToDisplayPixCode}
            startMinute={limitTimeInSecondsToDisplayPixCode === null ? 10 : 0}
            onFinish={handleFinish}
            displayHour={false}
          />
        </Styles.TimeMessage>
      </Styles.TimeMessageWrapper>

      <Styles.CopyWrapper>
        <CopySnippet
          width="full"
          content={code}
          withBorder
        />
      </Styles.CopyWrapper>

      <Styles.List data-testid="list">
        {list.map((item, index) => (
          <Styles.ListITem key={item}>
            <Styles.Circle>{index + 1}</Styles.Circle>
            {item}
          </Styles.ListITem>
        ))}

      </Styles.List>

    </Styles.Wrapper>
  );
};

export default PixContent;
